module.exports = __webpack_public_path__ + "img/info.78b1f0ec.svg";